// Глобальное исправление проблем с локализацией для избежания "Invalid language tag: en-US@posix"

import { normalizeLocale, formatDateSafe, formatNumberSafe } from '../utils/formatUtils';

// Сохраняем оригинальные методы
const originalToLocaleString = Date.prototype.toLocaleString;
const originalToLocaleDateString = Date.prototype.toLocaleDateString;
const originalToLocaleTimeString = Date.prototype.toLocaleTimeString;
const originalNumberToLocaleString = Number.prototype.toLocaleString;

// Переопределяем Date.prototype.toLocaleString для безопасного форматирования
Date.prototype.toLocaleString = function(locale, options) {
  try {
    if (!locale) {
      locale = 'en-US';
    }
    const normalizedLocale = normalizeLocale(locale);
    return originalToLocaleString.call(this, normalizedLocale, options);
  } catch (error) {
    console.warn('Date.toLocaleString fallback:', error.message);
    // Fallback к простому форматированию
    const d = new Date(this);
    return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  }
};

// Переопределяем Date.prototype.toLocaleDateString
Date.prototype.toLocaleDateString = function(locale, options) {
  try {
    if (!locale) {
      locale = 'en-US';
    }
    const normalizedLocale = normalizeLocale(locale);
    return originalToLocaleDateString.call(this, normalizedLocale, options);
  } catch (error) {
    console.warn('Date.toLocaleDateString fallback:', error.message);
    const d = new Date(this);
    return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`;
  }
};

// Переопределяем Date.prototype.toLocaleTimeString
Date.prototype.toLocaleTimeString = function(locale, options) {
  try {
    if (!locale) {
      locale = 'en-US';
    }
    const normalizedLocale = normalizeLocale(locale);
    return originalToLocaleTimeString.call(this, normalizedLocale, options);
  } catch (error) {
    console.warn('Date.toLocaleTimeString fallback:', error.message);
    const d = new Date(this);
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  }
};

// Переопределяем Number.prototype.toLocaleString для безопасного форматирования чисел
Number.prototype.toLocaleString = function(locale, options) {
  try {
    if (!locale) {
      locale = 'en-US';
    }
    const normalizedLocale = normalizeLocale(locale);
    return originalNumberToLocaleString.call(this, normalizedLocale, options);
  } catch (error) {
    console.warn('Number.toLocaleString fallback:', error.message);
    // Fallback к простому форматированию с запятыми
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

// Также переопределим Intl.DateTimeFormat для безопасности
const originalDateTimeFormat = Intl.DateTimeFormat;
Intl.DateTimeFormat = function(locale, options) {
  try {
    const normalizedLocale = locale ? normalizeLocale(locale) : 'en-US';
    return new originalDateTimeFormat(normalizedLocale, options);
  } catch (error) {
    console.warn('Intl.DateTimeFormat fallback:', error.message);
    return new originalDateTimeFormat('en-US', options);
  }
};

// Переопределим Intl.NumberFormat для безопасности  
const originalNumberFormat = Intl.NumberFormat;
Intl.NumberFormat = function(locale, options) {
  try {
    const normalizedLocale = locale ? normalizeLocale(locale) : 'en-US';
    return new originalNumberFormat(normalizedLocale, options);
  } catch (error) {
    console.warn('Intl.NumberFormat fallback:', error.message);
    return new originalNumberFormat('en-US', options);
  }
};

console.log('✅ Locale fixes applied - Date and Number prototype methods patched');

export default {};